// Auto-generated normalizer for table: Cat_Ocupaciones
export function catOcupacionesNormalize(row) {
  return {
    idOcupacion: row.idOcupacion ?? row.IdOcupacion ?? row['IdOcupacion'] ?? 0,
    idPersona: row.idPersona ?? row.IdPersona ?? row['IdPersona'] ?? 0,
    puesto: row.puesto ?? row.Puesto ?? row['Puesto'] ?? '',
    departamento: row.departamento ?? row.Departamento ?? row['Departamento'] ?? '',
    empresa: row.empresa ?? row.Empresa ?? row['Empresa'] ?? '',
    fechaInicio: row.fechaInicio ?? row.FechaInicio ?? row['FechaInicio'] ?? null,
    fechaFin: row.fechaFin ?? row.FechaFin ?? row['FechaFin'] ?? null,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
